// removed by extract-text-webpack-plugin
module.exports = {"materialize-textarea":"style__materialize-textarea___3BWxi","modal-2463794813":"style__modal-2463794813___2xGxh","container":"style__container___3_NdK","activeClass":"style__activeClass___FGimM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Createtabs/style.scss
// module id = 1481
// module chunks = 0